export default __webpack_public_path__ + "static/media/Pepper.d126cdea.jpg";